
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/go",
      function () {
        return require("private-next-pages/go.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/go"])
      });
    }
  